/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {KTIcon} from '../../../../../../../_metronic/helpers'
import {StepProps} from '../IAppModels'
import {Proposal} from '../../../proposals/core/_models'

type Props = {
  proposals?: Proposal[]
  setSelectedProposals: (proposal: Proposal[]) => void
  selectedProposals: Proposal[]
}

const Step1 = ({data, updateData, hasError}: StepProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [isSearching, setIsSearching] = useState<boolean>(false)

  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*begin::Form Group */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Proposta</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify your unique app name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='appname'
            placeholder='Digite o número da proposta'
            value={data.appBasic.appName}
            onChange={(e) =>
              updateData({
                appBasic: {
                  appName: e.target.value,
                  appType: data.appBasic.appType,
                },
              })
            }
          />
          {!data.appBasic.appName && hasError && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                Número da proposta é obrigatório
              </div>
            </div>
          )}
        </div>
        {/*end::Form Group */}

        <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
          <thead>
            <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
              <th>Proposta</th>
              <th>Tipo</th>
              <th>Urgente?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>3231299</td>
              <td>
                <select>
                  <option value='fisico'>Fisico</option>
                  <option value='digital'>Digital</option>
                </select>
              </td>
              <td>
                <select>
                  <option value='sim'>Sim</option>
                  <option value='nao'>Não</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>3421322</td>
              <td>
                <select>
                  <option value='fisico'>Fisico</option>
                  <option value='digital'>Digital</option>
                </select>
              </td>
              <td>
                <select>
                  <option value='sim'>Sim</option>
                  <option value='nao'>Não</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>35762712</td>
              <td>
                <select>
                  <option value='fisico'>Fisico</option>
                  <option value='digital'>Digital</option>
                </select>
              </td>
              <td>
                <select>
                  <option value='sim'>Sim</option>
                  <option value='nao'>Não</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export {Step1}
